import { render, staticRenderFns } from "./LikertAnswerContainer.vue?vue&type=template&id=1572510d&scoped=true&"
import script from "./LikertAnswerContainer.vue?vue&type=script&lang=js&"
export * from "./LikertAnswerContainer.vue?vue&type=script&lang=js&"
import style0 from "./LikertAnswerContainer.vue?vue&type=style&index=0&id=1572510d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1572510d",
  null
  
)

export default component.exports